module.exports = __webpack_public_path__ + "img/checkBoxBorder.a3d16ddc.svg";